import { defineStore, acceptHMRUpdate } from 'pinia';

const store = defineStore('ui-saving', {
  state: () => {
    return {
      inprogress: false,
      saveagain: false,
      success: false,
      error: '',
      errorCount: 0, // error message is not displayed until errorCount > 1 (trying to resolve conflicts automatically first)
    };
  },

  actions: {
    start() {
      this.inprogress = true;
      this.saveagain = false;
      this.success = false;
      this.error = '';
      // keep errorCount
    },
    setSuccess() {
      this.inprogress = false;
      // keep saveagain
      this.success = true;
      this.error = '';
      this.errorCount = 0;
    },
    setError(message) {
      this.inprogress = false;
      // keep saveagain
      this.success = false;
      this.error = message || true;
      this.errorCount += 1;
    },
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
